import { useLazyQuery } from '@apollo/client';
import { QuantityWaitlistPagination } from 'graphql-query-contracts';
import { getQuantityWaitlistQuery } from 'graphql-queries';
import { SortDirectionEnum } from 'constants-activate';

type QuantityWaitlistPaginationResponse = {
  quantityWaitlistForAdmin: QuantityWaitlistPagination;
};

const FETCH_POLICY = 'network-only';

export function useGetQuantityWaitlist() {
  const [fetchWaitlists, { data, loading }] =
    useLazyQuery<QuantityWaitlistPaginationResponse>(getQuantityWaitlistQuery, {
      fetchPolicy: FETCH_POLICY,
    });

  async function fetchQuantityWaitlists({
    contentId,
    channelId,
    search,
    page,
    pageSize,
  }: {
    contentId: string;
    channelId: string;
    search: {
      sortBy: {
        key: string;
        dir: SortDirectionEnum;
      };
      afterEndDate: string;
    };
    page: number;
    pageSize: number;
  }) {
    await fetchWaitlists({
      variables: {
        contentId,
        channelId,
        search,
        pagination: {
          start: page * pageSize,
          perPage: pageSize,
        },
      },
    });
  }

  return {
    getQuantityWaitlists: fetchQuantityWaitlists,
    isLoading: loading,
    waitlists: data?.quantityWaitlistForAdmin,
  };
}
